import React from 'react';
import PropTypes from 'prop-types';
import onError from '../../../utils/onError';

import './ErrorBoundary.module.scss';

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    displayErrorMessaging: PropTypes.bool,
  };

  static defaultProps = {
    displayErrorMessaging: true,
  };

  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    const renderingError = new Error(error.message);

    renderingError.name = 'ReactRenderingError';
    renderingError.stack = errorInfo.componentStack;
    renderingError.cause = error;
    onError(renderingError, {
      metadata: {
        react: errorInfo,
      },
    });

    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children, displayErrorMessaging } = this.props;

    if (error || errorInfo) {
      if (displayErrorMessaging) {
        return (
          <div styleName="error-container" data-testid="error-container">
            <div styleName="error-body">
              Something went wrong - like wearing socks with sandals.
            </div>

            <div styleName="error-body">Please go back and try again.</div>
          </div>
        );
      }

      return '';
    }

    return children;
  }
}

export default ErrorBoundary;
